{{ displayValue | number: numberFormat }}
